<div class="detalhamento-pendencias">
    <div class="detalhamento-header">
        @if (!voltarNoCard()) {
            <p-button icon="pi pi-arrow-left" [label]="rotuloVoltar()" (onClick)="voltarParaMapa()"></p-button>
        }
    </div>

    <div class="detalhamento-conteudo">
        <div class="detalhamento-card">
            @if (indicador(); as indicador) {
                <div class="card-entrada card-entrada-1" [ngClass]="indicador.classeGrupo" style="height: 100%">
                    <app-card-content [border]="false" [headerColor]="false" [title]="indicador.titulo" [subtitle]="indicador.descricao" [icon]="obterIconeIndicador(indicador.grupo)">
                        @if (voltarNoCard()) {
                            <p-button icon="pi pi-arrow-left" [label]="rotuloVoltar()" styleClass="p-button-outlined" [size]="'small'" (onClick)="voltarParaMapa()" card-header></p-button>
                        }

                        <div class="estatistica-total-bloco">
                            @if (indicador.quantidade !== null) {
                                <span class="estatistica-total-valor">{{ indicador.quantidade | number }}</span>
                                <span class="estatistica-total-label">registros</span>
                            } @else {
                                <div class="flex flex-col gap-0.5">
                                    <div class="indicador-placeholder">Sem dados</div>
                                    <div class="indicador-label">aguardando carga</div>
                                </div>
                            }
                        </div>
                    </app-card-content>
                </div>
            } @else {
                <div class="indicador-vazio">Nenhum indicador selecionado.</div>
            }

            <ng-content select="[detalhamento-acoes]"></ng-content>
            <ng-content select="[detalhamento-filtros]"></ng-content>
        </div>

        <div class="detalhamento-tabela">
            <app-custom-table
                [data]="dadosTabela()"
                [metadata]="tabelaMetadata()"
                [loading]="carregando()"
                [first]="first()"
                [rows]="rows()"
                [totalRecords]="totalRecords()"
                [rowsPerPageOptions]="[100, 200, 300, 400, 500]"
                [showViewSwitcher]="permitirVisualizacaoCard()"
                [initialViewMode]="'table'"
                [showActions]="false"
                [showExpandButton]="false"
                [showExport]="!carregando() && (linhas().length > 0 || !!provedorExportacao())"
                [exportFileName]="nomeArquivoCsv()"
                [exportProvider]="exportProviderTabela()"
                (onPageChange)="onPageChange($event)"
            ></app-custom-table>
        </div>
    </div>
</div>
